import { Reducer } from "redux";

import { get404InitialData } from "../utils";
import { AuthHistoryDispatchTypes } from "../models/DispatchTypes/AllPatientRecord";
import { AuthorizationHistoryResponse } from "../models/Api/Authorization";
import { AuthorizationHistoryDispatchTypes } from "../constants/Authorization";

const initialState: AuthorizationHistoryResponse = {
  loading: false,
  response: {
    totalRows: 0,
    authorizationHistory: [],
  },
};

const AllPatientRecordReducer: Reducer<
AuthorizationHistoryResponse,
AuthHistoryDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case AuthorizationHistoryDispatchTypes.GET_AUTH_HISTORY_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case AuthorizationHistoryDispatchTypes.GET_AUTH_HISTORY_SUCCESS: {
      return {
        ...state,
        response: get404InitialData(action.response, []),
        loading: false,
      };
    }
    case AuthorizationHistoryDispatchTypes.GET_AUTH_HISTORY_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.response,
      };
    }
  }
  return state;
};

export default AllPatientRecordReducer;
